import { cn } from '@magicdoorinc/ui';
import { getLeaseFullname } from './utils';
import type { HydratedLeaseDto } from '~/swagger/portal/Api';

interface LeaseNameProps {
  lease?: HydratedLeaseDto;
  class?: string;
}

export const LeaseName = (props: LeaseNameProps) => {
  return (
    <div class={cn('max-w-full cursor-pointer break-words text-sm font-medium text-text-01', props.class)}>
      {getLeaseFullname(props.lease)}
    </div>
  );
};
